/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './blood-inventory-investigation.reducer';

export const BloodInventoryInvestigationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bloodInventoryInvestigationEntity = useAppSelector(state => state.bloodInventoryInvestigation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bloodInventoryInvestigationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.bloodInventoryInvestigation.detail.title">BloodInventoryInvestigation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.bloodInventoryInvestigation.id">Id</Translate>
            </span>
          </dt>
          <dd>{bloodInventoryInvestigationEntity.id}</dd>
          <dt>
            <span id="result">
              <Translate contentKey="tinyMedicRestApp.bloodInventoryInvestigation.result">Result</Translate>
            </span>
          </dt>
          <dd>{bloodInventoryInvestigationEntity.result}</dd>
          <dt>
            <span id="observation">
              <Translate contentKey="tinyMedicRestApp.bloodInventoryInvestigation.observation">Observation</Translate>
            </span>
          </dt>
          <dd>{bloodInventoryInvestigationEntity.observation}</dd>
          <dt>
            <span id="statusCode">
              <Translate contentKey="tinyMedicRestApp.bloodInventoryInvestigation.statusCode">Status Code</Translate>
            </span>
          </dt>
          <dd>{bloodInventoryInvestigationEntity.statusCode}</dd>
          <dt>
            <span id="limits">
              <Translate contentKey="tinyMedicRestApp.bloodInventoryInvestigation.limits">Limits</Translate>
            </span>
          </dt>
          <dd>{bloodInventoryInvestigationEntity.limits}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.bloodInventoryInvestigation.active">Active</Translate>
            </span>
          </dt>
          <dd>{bloodInventoryInvestigationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.bloodInventoryInvestigation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{bloodInventoryInvestigationEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.bloodInventoryInvestigation.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{bloodInventoryInvestigationEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.bloodInventoryInvestigation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{bloodInventoryInvestigationEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.bloodInventoryInvestigation.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{bloodInventoryInvestigationEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodInventoryInvestigation.test">Test</Translate>
          </dt>
          <dd>{bloodInventoryInvestigationEntity.test ? bloodInventoryInvestigationEntity.test.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodInventoryInvestigation.baseTest">Base Test</Translate>
          </dt>
          <dd>{bloodInventoryInvestigationEntity.baseTest ? bloodInventoryInvestigationEntity.baseTest.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodInventoryInvestigation.donation">Donation</Translate>
          </dt>
          <dd>{bloodInventoryInvestigationEntity.donation ? bloodInventoryInvestigationEntity.donation.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodInventoryInvestigation.bank">Bank</Translate>
          </dt>
          <dd>{bloodInventoryInvestigationEntity.bank ? bloodInventoryInvestigationEntity.bank.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodInventoryInvestigation.bloodBankInventory">Blood Bank Inventory</Translate>
          </dt>
          <dd>{bloodInventoryInvestigationEntity.bloodBankInventory ? bloodInventoryInvestigationEntity.bloodBankInventory.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/blood-inventory-investigation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/blood-inventory-investigation/${bloodInventoryInvestigationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BloodInventoryInvestigationDetail;
